<template>
  <v-card>
    <v-flex pa-3 xs12>
      <v-flex
        xs12
      >
        <div>
          <div class="label py-0">
            {{ $tc('message.bizgainOnboarding.openingHoursDays') }}
          </div>
          <v-autocomplete
            class="pt-0"
            v-model="selectedDays"
            :items="weekDays"
            item-text="name"
            item-value="id"
            :placeholder="`Ex: ${weekDays.map(weekDay=>weekDay.name).join(',')}`"
            name="selectedDays"
            v-validate="'required'"
            @focus="clearErrorByField($event, 'selectedDays')"
            :error="errors.has('selectedDays')"
            :error-messages="
              errors.first('selectedDays')
                ? $t(
                  'message.bizgainOnboarding.openingHoursSelectedDay')
                : null
            "
            small-chips
            multiple
            append-icon="keyboard_arrow_down"
            :menu-props="{ maxHeight: 200 }"
            :return-object="true"
          >
            <v-list-tile
              slot="prepend-item"
              @click="toggle"
            >
              <v-list-tile-avatar>
                <v-checkbox :input-value="selectedAllDays" color="primary" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title :class="{ 'primary--text' : selectedAllDays, 'black--text': selectedSomeDays }">
                  {{ $tc('message.bizgainOnboarding.openingHoursAllDays') }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-slot:selection="data">
              <v-chip
                small
                color="primary-transperant-variant"
                text-color="black"
                :selected="data.selected"
              >
                <span>{{ data.item.name }}</span>
                <v-icon
                  small
                  class="pr-1"
                  right
                  color="black"
                  @click="removeWeekDay(data.item)"
                >
                  close
                </v-icon>
              </v-chip>
            </template>
          </v-autocomplete>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-layout wrap>
          <v-flex
            sm12
            xs12
            d-flex
            class="py-0 my-0"
          >
            <div class="label py-0">
              {{ $tc('message.bizgainOnboarding.openingHoursTime') }}
            </div>
          </v-flex>
          <v-flex
            xs5
            sm3
            md2
            d-flex
            class="py-0 my-0"
          >
            <v-select
              class="pt-1 my-0 px-0 time-dropdown"
              :items="openingTimeList"
              name="openingTime"
              item-text="label"
              item-value="value"
              :error="errors.has('openingTime')"
              :error-messages="
                errors.first('openingTime')
                  ? $t(
                    'message.bizgainOnboarding.openingHoursOpeningTime')
                  : null
              "
              v-model="openingTime"
              append-icon="keyboard_arrow_down"
            />
          </v-flex>
          <v-flex
            xs2
            md1
            sm2
            class="label px-3 pt-1 text-xs-center"
          >
            {{ $tc('message.bizgainOnboarding.openingHoursFromTo') }}
          </v-flex>
          <v-flex
            xs5
            sm3
            md2
            d-flex
            class="py-0 my-0"
          >
            <v-select
              class="pt-1 my-0 time-dropdown"
              :items="closingTimeList"
              item-text="label"
              item-value="value"
              name="closingTime"
              :error="errors.has('closingTime')"
              :error-messages="
                errors.first('closingTime')
                  ? $t(
                    'message.bizgainOnboarding.openingHoursClosingTime')
                  : null
              "
              v-model="closingTime"
              append-icon="keyboard_arrow_down"
            />
          </v-flex>
        </v-layout>
        <v-layout
          v-if="isDurationIs24hours"
        >
          <alert
            :icon-color="'primary'"
            :icon-width="`${ !$vuetify.breakpoint.xsOnly ? 'xs1' : 'xs2' }`"
            :outline="true"
            :outline-color="'primary'"
            :message="$t('message.bizgainOnboarding.openingHoursDurationMessage')"
            :col-width="'xs12'"
          />
        </v-layout>
      </v-flex>
    </v-flex>
  </v-card>
</template>
<script>
import {
  VLayout,
  VFlex,
  VAutocomplete,
  VChip,
  VIcon,
  VSelect,
  VCheckbox,
  VListTile,
  VListTileAvatar,
  VListTileContent,
  VListTileTitle,
  VCard
} from 'vuetify/lib';
import { weekDays, bizgainOnboardingRoutes } from 'Features/bizgainOnboarding/constants';
import moment from 'moment';
import clearErrorByField from 'Mixins/clearErrorByField';
import Alert from 'Components/Alert/Alert';
export default {
  mixins: [clearErrorByField],
  components: {
    VLayout,
    VFlex,
    VAutocomplete,
    VChip,
    VIcon,
    VSelect,
    VCheckbox,
    VListTile,
    VListTileAvatar,
    VListTileContent,
    VListTileTitle,
    Alert,
    VCard
  },
  data() {
    return {
      weekDays,
      selectedDays: [],
      openingTime: null,
      closingTime: null,
      isUpdateOpeningHours: false,
      bizgainOnboardingRoutes
    }
  },
  props: {
    callHours: {
      type: Array,
      default: () => []
    }
  },
  async created() {
    if(this.callHours){
      this.selectedDays = this.weekDays.filter(wD=>{
        return this.callHours.find(oH=>oH.dayOfWeek == wD.id);
      });
      this.openingTime = this.getClosestFifteenMinuteInterval(moment.utc(this.callHours[0].openingTime)).format('HH:mm');
      this.closingTime = this.getClosestFifteenMinuteInterval(moment.utc(this.callHours[0].closingTime)).format('HH:mm');
    }
  },
  computed: {
    openingTimeList(){
      return this.generateHours();
    },
    closingTimeList(){
      return this.generateHours();
    },
    selectedAllDays () {
      return this.weekDays.length === this.selectedDays.length;
    },
    selectedSomeDays () {
      return this.selectedDays.length > 0 && !this.selectedAllDays;
    },
    isOpeningHoursDetailsProvided() {
      return this.selectedDays.length > 0;
    },
    isDurationIs24hours(){
      let openingTimeWithFormat = moment.utc(this.openingTime, 'HHmm').format('YYYY-MM-DDTHH:mm');
      let closingTimeWithFormat = moment.utc(this.closingTime, 'HHmm').format('YYYY-MM-DDTHH:mm');
      let diff = moment.duration(moment(closingTimeWithFormat).diff(moment(openingTimeWithFormat))).asHours();
      openingTimeWithFormat = moment.utc(openingTimeWithFormat).format('HH:mm');
      closingTimeWithFormat = moment.utc(closingTimeWithFormat).format('HH:mm');
      return diff == 0 && (openingTimeWithFormat == '00:00' && closingTimeWithFormat == '00:00');
    }
  },
  methods: {
    updateCallHours(){
      let updatedCallHours = [];
      let openingTimeWithFormat = moment.utc(this.openingTime, 'HHmm').format('YYYY-MM-DDTHH:mm');
      let closingTimeWithFormat = moment.utc(this.closingTime, 'HHmm').format('YYYY-MM-DDTHH:mm');
      this.selectedDays.forEach(sD=>{
        updatedCallHours.push({ dayOfWeek: sD.id, openingTime: openingTimeWithFormat, closingTime: closingTimeWithFormat });
      });
      this.$emit('callHoursUpdate', updatedCallHours);
    },
    removeWeekDay (weekDay) {
      this.selectedDays.splice(this.selectedDays.indexOf(weekDay), 1);
    },
    generateHours() {
      return Array.from({
        length: 24
      }, (v, index) => {
        return [0, 15, 30, 45].map((interval) => {
          let label = moment({
            hour: index,
            minute: interval
          })
            .format('hh:mm a');
          let value = moment({
            hour: index,
            minute: interval
          })
            .add(0, 'hours')
            .format('HH:mm');
          return { label, value };
        });
      }).flat()
    },
    toggle () {
      this.$nextTick(() => {
        if (this.selectedAllDays) {
          this.selectedDays = []
        } else {
          this.selectedDays = this.weekDays.slice()
        }
      })
    },
    getClosestFifteenMinuteInterval (dateTime) {
      if (!moment.isMoment(dateTime)) {
        return dateTime;
      }

      var moduloMinutes = dateTime.minutes() % 15;
      if (moduloMinutes >= 8) {
        dateTime.add(15 - moduloMinutes, 'minutes');
      }
      else {
        dateTime.subtract(moduloMinutes, 'minutes');
      }

      return dateTime;
    },
    discardChanges(){
      this.selectedDays = [];
      this.openingTime = null;
      this.closingTime = null;
    }
  },
  watch: {
    selectedDays(){
      this.updateCallHours();
    },
    openingTime(){
      this.updateCallHours();
    },
    closingTime(){
      this.updateCallHours();
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .time-dropdown {
  margin: 0px;
  padding: 0px;
  .v-input__control {
    margin: 0px;
    padding: 0px;
    .v-input__slot {
      .v-select__slot {
        .v-select__selections {
          .v-select__selection--comma {
            max-width: 92px;
            white-space: nowrap;
          }
        }
        .v-input__append-inner {
          margin-left: 0px !important;
          padding-left: 0px !important;
        }
      }
    }
  }
}
</style>
